export const faqTranslations = {
  FAQ_TITLE: 'FAQ',
  FAQ_SUBTITLE: 'Frequent asked questions',
}
